<template>
  <router-view />
  <LoadingSAP v-if="this.$store.state.loading" />
  <Loading v-if="this.$store.state.loadingPattern" />
  <LoadingProgress
    v-if="this.$store.state.loadingPatternProgress.status"
    :progress="this.$store.state.loadingPatternProgress.progress"
    :loading="this.$store.state.loadingPatternProgress.loading"
    :total="this.$store.state.loadingPatternProgress.total"
  />
</template>

<script>
import LoadingSAP from "./components/LoadingSAP.vue";
import Loading from "./components/Loading.vue";
import LoadingProgress from "./components/LoadingProgress.vue";

export default {
  name: "App",
  components: {
    LoadingSAP,
    Loading,
    LoadingProgress,
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* //responsive font */
html {
  @media (max-width: 1080px) {
    font-size: 93.75%;
    /* //16*0,9373= 15px */
  }

  @media (max-width: 768px) {
    font-size: 87.5%;
    /* //16*0,875 = 14px */
  }
}

:root {
  --green: #1cc88a;
  --darkgreen: #049c62;
  --borderGreen: #baf3cd;
  --borderInput: #baf3cd;
  --red: #f80000;
  --redTransparent: #ff9f9f;
  --blue: #18a0fb;
  --btnBlue: #18a0fb;
  --black: #000;
  --yellow: #efe031;
  --orange: #ff8c00;
  --purple: #8b008b;
  --white: #fff;
  --grayBody: #f9f9f9;
  --cards: #d6d6d6;
  --cinza: #cccccc;
  --greyBtn: #858796;
  --gray: #5e5e5e;
  --grey: #c5c5c54d;
  --inputColor: #38383b;

  /* colors */
  --white: #ffffff;
  --bg: #f9f9f9;
  --bgProcess: #c9c9c9;
  --gray: #e5e5e5;
  --green: #1cc88a;
  --orange: rgb(231, 76, 71);
  --gray_text: #c8d6e5;
  --black_text: #444444;
  --black_text_print: #636363;
  --gradient-green: linear-gradient(360deg, var(--green) 0, #466451 116%);

  /* border radius */
  --radius: 0.625rem;
  --circuleRadius: 50%;

  /* shadow */
  --shadow: 0px 0px 1rem #d2d2d2a6;

  /* padding */
  --paddingInput: 0.5rem;
  --negativeSpace: 2vw;
  /* weight */
  --bold: 600;
  --regular: 400;

  /* // print out */
  --border_card: 1px solid var(--gray);
  --border_print: 1px solid var(--black_text);
}

@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;600&display=swap");

body {
  font-family: "Poppins", sans-serif;
  background-color: var(--bg);
  color: var(--black_text);
}

h1 {
  margin: 0;
}
h3{
  font-size: 1rem;
  font-weight: 500
}
*:focus {
  outline: none;
}

::placeholder {
  font-weight: 400;
}

a.nuxt-link-exact-active {
  border: 2px solid color("b-green");
}

a.nuxt-link {
  border: none;
}

button {
  cursor: pointer;
  border: none;
}

a {
  text-decoration: none;
  color: var(--black_text);
}
tbody{
  background: var(--white);
}
tr{
  border-bottom: 1px solid var(--gray_text);
}
input{
  height: 2.6rem !important;
  border: 1px solid var(--gray_text) !important;
}
</style>
